module.exports = __webpack_public_path__ + "assets/img/20_967.0dee7289.jpg";